import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled, useA11yKeyEvent, useDeprecatedCheck, useThemeProps, } from '../../foundation';
import { LinkStyle } from './styles';
var _RcLink = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcLink' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcLink, props, [
            {
                prop: 'size',
                time: '2021-4',
                comment: "@deprecated size of Link, default is medium, please use variant directly\n * `small` => `caption1`\n * `medium` => `body1`\n * `large` => `headline1`\n */",
            },
            {
                prop: 'handleOnClick',
                time: '2021-4',
                comment: "@deprecated use onClick replace that */",
            },
        ]);
    }
    var _handleOnClick = props.handleOnClick, ComponentProp = props.Component, onKeyDown = props.onKeyDown, onClick = props.onClick, disabled = props.disabled, children = props.children, tabIndex = props.tabIndex, color = props.color, underline = props.underline, variant = props.variant, rest = __rest(props, ["handleOnClick", "Component", "onKeyDown", "onClick", "disabled", "children", "tabIndex", "color", "underline", "variant"]);
    // TODO: remove when handleOnClick removed
    var handleOnClick = _handleOnClick ? _handleOnClick : onClick;
    var handleOnKeyDown = useA11yKeyEvent(handleOnClick, {
        checkKeys: ['Enter'],
    });
    // * prevent tsc error with dynamic component type
    var Component = ComponentProp;
    return (React.createElement(Component, __assign({}, rest, { tabIndex: disabled ? -1 : tabIndex, ref: ref, onClick: handleOnClick, onKeyDown: onKeyDown || handleOnKeyDown }), children));
});
/**
 * @release
 * that onClick event will be trigger with `enter` like `<a>`, when have custom onKeydown event, that will be cover by outside
 * */
var RcLink = styled(_RcLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LinkStyle);
RcLink.defaultProps = {
    variant: 'body1',
    color: 'informative.f02',
    disabled: false,
    Component: 'a',
};
RcLink.displayName = 'RcLink';
export { RcLink };
var templateObject_1;
